import { render, staticRenderFns } from "./updateVector.vue?vue&type=template&id=4538343d&scoped=true"
import script from "./updateVector.vue?vue&type=script&lang=js"
export * from "./updateVector.vue?vue&type=script&lang=js"
import style0 from "./updateVector.vue?vue&type=style&index=0&id=4538343d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4538343d",
  null
  
)

export default component.exports